import React from "react"
import styled from "styled-components"
import BefitRole from "./BefitRole"

export default function Befit({ befit }) {
  return (
    <Wrapper className="Befit">
      <TitleWrapper>適合一起投資的朋友</TitleWrapper>
      <BefitRoleWrapper>
        {befit?.map((role, index) => (
          <BefitRole key={index} title={role.name} img={role.img} />
        ))}
      </BefitRoleWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex: 0;
  gap: 12px;
  flex-direction: column;
  justify-content: start;
`
const TitleWrapper = styled.h2`
  margin: 0;
  flex: 0 0 30px;
  text-shadow: 0 0 30px #00fff0;
  font-size: 24px;
  color: #00fff0;
  font-weight: 700;
`
const BefitRoleWrapper = styled.div`
  background: linear-gradient(
    135deg,
    rgba(0, 255, 238, 0.264),
    rgba(0, 255, 238, 0)
  );
  font-size: 16px;
  color: #00fff0;
  padding: 18px 24px 12px 24px;
  border: 1px solid #00fff0;
  border-radius: 12px;
  flex: 0;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 16px;
`
